import fpApiUtil from "./fp-api-util";

const ANALYSIS = "factoryplan/analysis";

// 공정(라인)별 계획 결과 — 크로스탭 그리드용. 백엔드가 피벗+집계까지 끝내서
// { crosstabHeader, chartHeader, data[].pivotData } 형태로 내려준다(AnalysisController#getPlanResults).
const getPlanResults = (params) => fpApiUtil.postParams(`${ANALYSIS}/plan-result`, params);

// 같은 엔드포인트의 차트용 호출 — 그리드에서 클릭한 행(plantCd/resourceCd/itemCd)으로 드릴다운하고,
// 그리드에 걸린 Set Filter 선택값을 `changes`(FilterParameter: plantCds/resourceCds/itemCds)로 함께 보낸다.
// `params` 하나만 보내는 postParams로는 부족해서 postFields를 쓴다(fp-report-screen-guide.md §A-6c).
const getPlanResultChart = (params, changes) =>
  fpApiUtil.postFields(`${ANALYSIS}/plan-result`, { params, changes });

const fpPlanResultService = { getPlanResults, getPlanResultChart };
export default fpPlanResultService;
